import script from "./houseManage.vue?vue&type=script&setup=true&lang=js"
export * from "./houseManage.vue?vue&type=script&setup=true&lang=js"

import "./houseManage.vue?vue&type=style&index=0&id=5c09c166&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c09c166"]])

export default __exports__